import { useCallback, useMemo, useState } from "react";

import useGoogleTagManager from "../../../../../hooks/useGTM";
import questionsData from "../data/questions.json";
import type {
  AccordionChangeHandler,
  CommonQuestion,
} from "./commonQuestionsTypes";

export const useCommonQuestions = () => {
  const { interactionEvent } = useGoogleTagManager();
  const [expanded, setExpanded] = useState<string | false>(false);

  const questions = useMemo(() => {
    return questionsData.questions as CommonQuestion[];
  }, []);

  const trackFaqClick = useCallback(
    (text: string) => {
      interactionEvent({
        event_action: "clicou",
        event_category: "faq",
        event_label: text,
        event_name: "duvidas_frequentes",
      });
    },
    [interactionEvent]
  );

  const handleChange: AccordionChangeHandler = useCallback(
    (panel, eventLabel) => (_event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);

      if (newExpanded && eventLabel) {
        trackFaqClick(eventLabel);
      }
    },
    [trackFaqClick]
  );

  return {
    questions,
    expanded,
    handleChange,
    gtmHandleClick: trackFaqClick,
  };
};